/**
 * Breakpoints for responsive design
 */
const breakpoints: Record<string, string> = {
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
};

export default breakpoints;
